import $ from "jquery";
export function ContrastSwitch() {
  function handleClick(e) {
    e.preventDefault();
    const contrast = $(e.target).data("contrast");
    $(document.body)
      .data("contrast", contrast)
      .attr("data-contrast", contrast);
    window.localStorage.setItem("telecubeContrast", contrast);
  }

  $(".js-contrast-changer").click(handleClick);

  $(document).ready(() => {
    if (window.localStorage.getItem("telecubeContrast")) {
      $(document.body)
        .data("contrast", window.localStorage.getItem("telecubeContrast"))
        .attr("data-contrast", window.localStorage.getItem("telecubeContrast"));
    }
  });
}

ContrastSwitch();
